// extracted by mini-css-extract-plugin
module.exports = {"Logo":"burgerLogo_Logo__ODvh2"};